/**
 * All the exchanges
 */

const EXCHANGES = {
    binanceus: 'Binance US',
    binance: 'Binance',
    felix: 'Felix',
    kraken: 'Kraken',
    coinbase: 'Coinbase',
    kucoin: 'Kucoin',
    bitmart: 'Bitmart',
    coinflex: 'CoinFLEX',
    huobi: 'Huobi',
    poloniex: 'Poloniex Spot',
    poloniexfutures: 'Poloniex Futures'
  };
  
  export { EXCHANGES };
